export default "__VITE_ASSET__CPyWBm3d__"